import React from 'react';
import { AboutHero } from '../components/inner/AboutHero';
import { AboutStory } from '../components/inner/AboutStory';
import { HomeStats } from '../components/home/HomeHero';
import { HomeReasons, HomeCrew } from '../components/home/HomeCommunity';
import { HomeLocations } from '../components/home/HomeLocations';
import '../styles/reference-home.css';
import '../styles/inner-pages.css';

export default function About() {
  return (
    <div className="reference-home inner-page about-page" data-testid="about-page">
      <AboutHero />
      <AboutStory />
      <HomeStats />
      <HomeReasons />
      <HomeCrew />
      <HomeLocations />
    </div>
  );
}